import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-182af5c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-page"
}

import { onMounted, reactive } from 'vue';
import { getTeacherUserPage } from './apiMethods';
import { TeacherUserPageResponse } from './UserPage.types';
import MenuList from '@/common/components/snedson-material-components/menu-list/menu-list.vue';
import UserHeader from '@/common/components/snedson-material-components/user-header/user-header.vue';
import AuthService from '@/services/AuthService';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPage',
  setup(__props) {

const state = reactive<{ data: TeacherUserPageResponse | null }>({
    data: null,
});

onMounted(() => {
    getTeacherUserPage().then((res) => {
        state.data = res.data;
        console.log(res);
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UserHeader, {
          props: {
                name: state.data.firstname,
                surname: state.data.surname,
                subheader: state.data.jobTitle,
            }
        }, null, 8, ["props"]),
        _createVNode(MenuList, {
          props: {
                items: [
                    {
                        icon: 'supervised_user_circle',
                        title: 'Классное руководство',
                        content: state.data.masterClass
                            ? state.data.masterClass.className
                            : 'Отсутствует',
                    },
                    {
                        icon: 'school',
                        title: 'Данные школы',
                    },
                    {
                        icon: 'logout',
                        title: 'Выход из аккаунта',
                        button: {
                            type: 'text',
                            iconName: 'logout',
                            innerText: 'Выйти',
                            size: 'full-resizable-to-icon-large',
                        },
                        buttonCallback: _unref(AuthService).logout,
                    },
                ],
            }
        }, null, 8, ["props"])
      ]))
    : _createCommentVNode("", true)
}
}

})